import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import MacieDetailBody from '../MacieDetailBody';

// Descriptor for the Macie engine — the 4th Security Hub capability. Same shape
// as cspm.js / guardduty.js; registering it in registry.js auto-wires the
// sidebar, Overview, EnableCapabilities panel, and unified findings inbox.
export const macieEngine = {
  id: 'macie',
  label: 'Amazon Macie',
  color: '#0d9488',
  Icon: FindInPageOutlinedIcon,
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND — EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  // Sidebar sub-items. They hang directly off the SECURITY HUB group —
  // there is no "Detection engines" grouping in PortalSidebar.
  nav: [
    { label: 'Dashboard', to: '/securityhub/macie' },
    { label: 'S3 buckets', to: '/securityhub/macie/buckets' },
    { label: 'Findings', to: '/securityhub/macie/findings' },
    { label: 'Enrollment', to: '/securityhub/macie/enrollment' },
    { label: 'Settings', to: '/securityhub/macie/settings' },
  ],
  enableRoute: '/securityhub/macie', // where "Enable/Configure" routes
  DetailBody: MacieDetailBody,
};
